import { __decorate } from 'tslib';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { shareReplay, map } from 'rxjs/operators';

/**
 * Servicio encargado de obtener las configuraciones del entorno
 * segun el archivo config.json que debe ser incluido en la ruta
 * assets/config y en la propiedad assets del archivo angular.json
 *
 * @example
 *
 * // Ejemplo para importar el archivo de configuración
 * {
 *  "projects": {
 *    "my-project": {
 *      "architect": {
 *        "build": {
 *          "options": {
 *            "assets": [
 *            ...
 *            "assets/config/config.json" <-- here
 *            ]
 *          }
 *        }
 *      }
 *    }
 *  }
 * }
 *
 * // Ejemplo para usar el servicio de configuración
 * export class AppComponent implements OnInit {
 *
 *  constructor(private configuration: NexaConfigurationService) { }
 *
 *  ngOnInit() {
 *    this.configuration.loadConfiguration().suscribe(data => console.log(data));
 *  }
 * }
 */
import * as ɵngcc0 from '@angular/core';
let NexaConfigurationService = class NexaConfigurationService {
    /**
     * Crea una nueva instancia de @see NexaConfigurationService
     */
    constructor() { }
    /**
     * Metodo encargado de cargar la configuración del entorno
     * @returns Retorna un Observable con las configuraciones del entorno de ejecuciòn
     */
    loadConfigurations(env) {
        if (!this.configuration$) {
            this.configuration$ = of(env).pipe(shareReplay(1));
        }
        return this.configuration$;
    }
    /**
     * Metodo encargado de validar si el entorno es desarrollo
     * @returns Retorna true si el entono configurado es Development
     */
    isDevelopment() {
        return this.configuration$.pipe(map((config) => config.environmentName === 'Development'));
    }
    /**
     * Metodo encargado de validar si el entorno es pruebas
     * @returns Retorna true si el entono configurado es Test
     */
    isTest() {
        return this.configuration$.pipe(map((config) => config.environmentName === 'Test'));
    }
    /**
     * Metodo encargado de validar si el entorno es producción
     * @returns Retorna true si el entono configurado es Production
     */
    isProduction() {
        return this.configuration$.pipe(map((config) => config.environmentName === 'Production'));
    }
    /**
     * Metodo encargado de validar si la configuración corresponde a un determinado entorno
     * @param environmentName Nombre del ambiente a verificar
     * @returns Retorna true si el entono configurado es igual a environmentName
     */
    isEnvironment(environmentName) {
        return this.configuration$.pipe(map((config) => config.environmentName === environmentName));
    }
    /**
     * Metodo encargado de consultar la uri de la api a partir del parametro @param id
     * @param id Id de la api a consultar
     * @returns Uri que corresponde al id especificado.
     */
    getApi(id) {
        return this.configuration$.pipe(map((config) => {
            if (!id) {
                throw new Error('Invalid id');
            }
            return config.apis[id];
        }));
    }
};
NexaConfigurationService.ɵfac = function NexaConfigurationService_Factory(t) { return new (t || NexaConfigurationService)(); };
NexaConfigurationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NexaConfigurationService, factory: function (t) { return NexaConfigurationService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NexaConfigurationService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Expone las configuraciones asignadas en el entorno de ejecución
 */
class Environment {
    /**
     * Crea una nueva instancia de @see Configuration
     */
    constructor() {
        /**
         * Información de las apis con las que se interactuan
         */
        this.apis = {};
        this.environmentName = 'Development';
    }
}

/**
 * Propiedades de configuración para conectar con el identity server
 */
class IdentityServer {
}

/*
 * Public API Surface of nexa-configuration
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Environment, IdentityServer, NexaConfigurationService };

